// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"6b988f20","2391":"5c6b8b75","3660":"07c94274","4069":"66e0e9f1","6374":"64abc70b","8016":"0123f880","8581":"5c6b8b75"}[chunkId] + ".chunk.css";
};